const unique = (arr)=>[
        ...new Set(arr)
    ];
export { unique };

//# sourceMappingURL=unique.mjs.map